(function () {
  var config = window.EBD_FREE_GIFTS;
  if (!config) return;
  var root = config.root.replace(/\/?$/, '/');
  var pending = Promise.resolve();

  async function request(path, body) {
    var options = { cache: 'no-store', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    var response = await fetch(root + path, options);
    var result = await response.json();
    if (!response.ok) throw new Error(config.error);
    return result;
  }

  function managed(item) {
    return item.properties && item.properties._free_gift === 'yes';
  }

  function nextChange(cart) {
    for (var rule of config.rules) {
      var trigger = cart.items.find(function (item) {
        return !managed(item) && item.quantity > 0 && rule.handles.includes(item.handle);
      });
      var matching = cart.items.filter(function (item) {
        return String(item.variant_id) === String(rule.variant);
      });
      var paid = matching.some(function (item) { return !managed(item); });
      var gifts = matching.filter(managed);
      var desired = trigger && !paid ? 1 : 0;
      for (var index = gifts.length - 1; index >= 0; index--) {
        var item = gifts[index];
        var quantity = index === 0 ? desired : 0;
        if (item.quantity !== quantity) {
          return { path: 'cart/change.js', body: { id: item.key, quantity: quantity } };
        }
      }
      if (desired && !gifts.length) {
        return { path: 'cart/add.js', body: { items: [{ id: rule.variant, quantity: 1,
          properties: { _free_gift: 'yes', _gift_rule: rule.id, _trigger: trigger.handle }
        }] } };
      }
    }
    return null;
  }

  async function reconcile() {
    var cart = await request('cart.js');
    for (var attempt = 0; attempt < 40; attempt++) {
      var change = nextChange(cart);
      if (!change) return cart;
      await request(change.path, change.body);
      cart = await request('cart.js');
    }
    throw new Error(config.error);
  }

  function verify(cart) {
    for (var rule of config.rules) {
      var eligible = cart.items.some(function (item) {
        return !managed(item) && item.quantity > 0 && rule.handles.includes(item.handle);
      });
      if (!eligible) continue;
      var gifts = cart.items.filter(function (item) {
        return String(item.variant_id) === String(rule.variant);
      });
      var freeUnit = gifts.some(function (item) {
        return item.original_line_price - item.final_line_price >= item.original_price;
      });
      if (!gifts.length || !freeUnit || gifts.some(function (item) {
        return managed(item) && item.final_line_price > 0;
      })) throw new Error(config.error);
    }
    return cart;
  }

  window.ebdFreeGifts = {
    label: config.label,
    reconcile: function (checkPrice) {
      var next = pending.then(reconcile).then(function (cart) {
        return checkPrice ? verify(cart) : cart;
      });
      pending = next.catch(function () {});
      return next;
    }
  };
  window.autoAddFreeGifts = function () { return window.ebdFreeGifts.reconcile(); };
  window.pruneOrphanFreeGifts = window.autoAddFreeGifts;
})();
